import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils/cn";
import { buttonVariants } from "./button-variants";
import { hoverPressEffect } from "@/shared/constants/styles";

function Button({
  className,
  variant,
  size,
  asChild = false,
  disabled = false,
  disEffect = false,
  onClick,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
    disEffect?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
  }) {
  const Comp = asChild ? Slot : "button";
  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      onClick?.(e as any);
    },
    [disabled, onClick]
  );

  return (
    <Comp
      data-slot="button"
      className={cn(
        {
          [hoverPressEffect]: !(disEffect || disabled),
        },
        buttonVariants({ variant, size }),
        {
          "opacity-50 cursor-not-allowed": disabled,
          "cursor-pointer": !disabled,
        },
        className
      )}
      onClick={handleClick}
      {...props}
    />
  );
}

export { Button };
